import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const libraries = ['places'];
const region = ['PH'];

const Location = ({ pinLocation, data }) => {

  const [lat, lng] = pinLocation.split(',');
  const position = pinLocation
    ? {
      lat: +lat,
      lng: +lng,
    }
    : {
      lat: 14.5964957,
      lng: 120.9445404,
    };

  if (!pinLocation) {
    return (
      <div className="text-center py-3">
        <b>LOCATION NOT FOUND</b>
      </div>
    );
  }

  const address = `${get(data, 'region_name') || '-'}
  ${get(data, 'province_name') || '-'} 
  ${get(data, 'municipality_name') || '-'} 
  ${get(data, 'barangay_name') || '-'} 
  ${get(data, 'street') || '-'}  
  ${get(data, 'zip_code') || '-'}`;

  return (
    <div className="p-3">
      <div className="text-primary font-weight-bold mb-2">Business Address</div>
      <div className="mb-4">{address || '-'}</div>
      <LoadScript
        region={region}
        libraries={libraries}
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_KEY}
      >
        <GoogleMap
          mapContainerStyle={{
            width: '100%',
            height: '400px',
          }}
          center={position}
          zoom={12}
        >
          <Marker position={position} />
        </GoogleMap>
      </LoadScript>
    </div>
  );
};

Location.defaultProps = {
  data: {},
}

Location.propTypes = {
  pinLocation: PropTypes.string.isRequired,
  data: PropTypes.instanceOf(Object),
};

export default Location;
